const Services = () => {
    return (
        <section id="services" className="services">
            <h2>Our Services</h2>
            <div className="service-grid">
                <div className="service-card">
                    <img src="/img/services/reppic.png" alt="RO Repair" />
                    <h4>RO Repair</h4>
                    <p>Fast and reliable RO repair services to restore pure drinking water at your home. Expert technicians ensure quick diagnosis and lasting solutions.</p>
                    <a href="#contact" className="btn">Book</a>
                </div>
                <div className="service-card">
                    <img src="/img/services/inspic.png" alt="Installation" />
                    <h4>Installation</h4>
                    <p>Professional RO installation for homes and offices with perfect fitting and setup. Enjoy safe, clean water from day one.</p>
                    <a href="#contact" className="btn">Book</a>
                </div>
                <div className="service-card">
                    <img src="/img/services/amcpic.png" alt="AMC" />
                    <h4>AMC Plans</h4>
                    <p>Affordable Annual Maintenance Contracts for worry-free RO performance all year. Regular servicing, priority support, and genuine spare parts included.</p>
                    <a href="#contact" className="btn">Book</a>
                </div>
                <div className="service-card">
                    <img src="/img/services/filpic.png" alt="Filter" />
                    <h4>Filter Replacement</h4>
                    <p>Timely filter replacements to maintain water purity and system efficiency. We use high-quality filters for better taste and safety.</p>
                    <a href="#contact" className="btn">Book</a>
                </div>
                <div className="service-card">
                    <img src="/img/services/compic.png" alt="Commercial" />
                    <h4>Commercial RO</h4>
                    <p>High-capacity commercial RO solutions for offices, schools, hospitals, and industries. Designed for consistent performance and large water demands.</p>
                    <a href="#contact" className="btn">Book</a>
                </div>
            </div>
        </section>
    );
};

export default Services;